import { z } from 'zod'

export const stringSchema = z.string().trim()

export const iso8601DateSchema = z
  .string()
  .trim()
  .regex(/^\d{1,4}-\d{1,2}-\d{1,2}$/, 'Invalid date')
  .transform((value) => {
    const [year, month, day] = value.split('-')

    return [
      year.padStart(4, '0'),
      month.padStart(2, '0'),
      day.padStart(2, '0'),
    ].join('-')
  })

export const addressSchema = z.object({
  line1:  stringSchema.nullish(),
  line2: stringSchema.nullish(),
  city:  stringSchema.nullish(),
  postcode:  stringSchema.nullish(),
  country:  stringSchema.nullish(),
})
